import { render, staticRenderFns } from "./joinUs.vue?vue&type=template&id=72fe6f9c&scoped=true&"
import script from "./joinUs.vue?vue&type=script&lang=js&"
export * from "./joinUs.vue?vue&type=script&lang=js&"
import style0 from "./joinUs.vue?vue&type=style&index=0&id=72fe6f9c&scoped=true&lang=less&"
import style1 from "./joinUs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fe6f9c",
  null
  
)

export default component.exports